import React, { useState } from 'react';//importing react hooks for state of components
import { Link } from 'react-router-dom';// importing link for linking chats/paths
import './Join.css';
const Join = () => {
 const [name, setName] = useState('');//declaring hooks, parameter - name, setname(func), passing initial value of name var, an empty string to usestate
 const [room, setRoom] = useState(''); 

 return(
     <div className="joinOuterContainer">
        <div className="joinInnerContainer">
        <h1 className="mheading" >JustTalk</h1>
        <h1 className="heading">Join</h1> 
        <div>
            <input placeholder="Name" className="joinInput" type="text" onChange={(event) => setName(event.target.value)}/>
            </div>
        <div>
            <input placeholder="Room" className="joinInput mt-20" type="text" onChange={(event) => setRoom(event.target.value)}/>
            </div>
        <Link onClick={event => (!name || !room) ? event.preventDefault() : null} to={`/chat?name=${name}&room=${room}`}>
         <button className="button mt-20" type="submit">Sign In</button>
        </Link>
        </div>
     </div>   
    );
}
export default Join;
